import { render, staticRenderFns } from "./DictOptLog.vue?vue&type=template&id=46dc7794&scoped=true"
import script from "./DictOptLog.vue?vue&type=script&lang=js"
export * from "./DictOptLog.vue?vue&type=script&lang=js"
import style0 from "./DictOptLog.vue?vue&type=style&index=0&id=46dc7794&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46dc7794",
  null
  
)

export default component.exports